import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

async function enableMocking() {
  // Disabled MSW to use real backend API
  // if (import.meta.env.DEV) {
  //   const { worker } = await import('./services/mock/browser')
  //   return worker.start({
  //     onUnhandledRequest: 'bypass',
  //   })
  // }
}

enableMocking().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
})
